module.exports = __webpack_public_path__ + "img/notifiation-icon-grey.6e5ec4f5.svg";